export default routesSchoolCommonRoom;

/** @ngInject */
function routesSchoolCommonRoom($stateProvider) {
  $stateProvider
    .state('schoolCommonRoom', {
      abstract: true,
      url: '/schoolCommonRoom',
      data: {
        title: 'Wybierz świetlicę',
        displayName: 'Wybierz świetlicę',
        hideNavbar: true
      },
      resolve: {
        user: SchoolCommonRoomService => SchoolCommonRoomService.getUser()
      },
      onEnter: ($state, user) => {
        if (user.isAdmin) {
          return $state.target('configuration.schoolCommonRooms');
        }
      }
    })
    .state('schoolCommonRoom.select', {
      url: '/select',
      views: {
        'content@': {
          component: 'selectSchoolCommonRoomComponent'
        }
      },
      resolve: {
        schoolCommonRooms: SchoolCommonRoomService => SchoolCommonRoomService.getSchoolCommonRooms(true)
      },
      onEnter: ($log, $rootScope, $state, schoolCommonRooms, ClassRoomService, SchoolCommonRoomService) => {
        if (schoolCommonRooms.length === 1) {
          if (!SchoolCommonRoomService.getCurrentSchoolCommonRoom()) {
            SchoolCommonRoomService.setMySchoolCommonRoom(schoolCommonRooms[0]);
          }

          if (schoolCommonRooms[0].configurationCompleted) {
            ClassRoomService.getClassRooms(false, schoolCommonRooms[0].id).then(result => {
              if (result.length === 1) {
                return $state.go('modules.dashboard', {}, {reload: true});
              }
            });
          }
        }
      }
    });
}
